import { CreateLinkLoadingGIF } from "@/config/config";

const CommonLoading = ({ className }) => {
  return <img className={`!w-[30px] !h-[30px] ${className}`} src={CreateLinkLoadingGIF} />;
};

export default CommonLoading;
